import { BetManager, Bus } from '@atlas/core';

const addBetBoosterWindowFunctions = () => {
  window.selectOutcome = params => {
    const { betGroups, eventId, marketId, marketTypeId, outcomeId } = params;

    BetManager.selectBet({
      eventId,
      marketTypeId,
      marketId,
      outcomeId,
      betGroups,
    });
  };

  window.onInsightsCountChanged = (homeName, awayName, insightsCount) => {
    Bus.send({
      event: 'betBooster:insidesChanged',
      data: {
        homeName,
        awayName,
        insightsCount,
      },
    });
  };
};

export default addBetBoosterWindowFunctions;
